import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../images/logowithnamewhite.png";

const getHeaderOffset = (sectionId) => {
  const isMobile = window.matchMedia("(max-width: 900px)").matches;

  if (sectionId === "planner") return isMobile ? 92 : 115;
  return isMobile ? 82 : 100;
};

const scrollToElement = (sectionId) => {
  const section = document.getElementById(sectionId);

  if (!section) return;

  const sectionPosition = section.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: sectionPosition - getHeaderOffset(sectionId),
    behavior: "smooth",
  });
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const scrollTarget = sessionStorage.getItem("scrollTarget");

    if (location.pathname === "/" && scrollTarget) {
      sessionStorage.removeItem("scrollTarget");

      const timer = setTimeout(() => {
        scrollToElement(scrollTarget);
      }, 100);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, [location.pathname]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsMenuOpen(false);
    };

    document.body.classList.add("nav-open");
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.classList.remove("nav-open");
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isMenuOpen]);

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false);

    if (location.pathname === "/") {
      scrollToElement(sectionId);
    } else {
      sessionStorage.setItem("scrollTarget", sectionId);
      navigate("/");
    }
  };

  return (
    <header className="site-nav">
      <Link to="/" className="brand" aria-label="Teamward home">
        <img src={logo} alt="Teamward" />
      </Link>

      <button
        type="button"
        className="mobile-menu-toggle"
        aria-expanded={isMenuOpen}
        aria-controls="teamward-main-menu"
        aria-label={
          isMenuOpen ? "Close navigation menu" : "Open navigation menu"
        }
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        <span className="mobile-menu-icon" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
        <span className="mobile-menu-label">Menu</span>
      </button>

      <nav
        id="teamward-main-menu"
        className={`site-menu${isMenuOpen ? " is-open" : ""}`}
        aria-label="Main navigation"
      >
        <button
          type="button"
          className="nav-link"
          onClick={() => scrollToSection("planner")}
        >
          Find the Right Experience
        </button>

        <Link
          to="/quote-builder"
          className="nav-link"
          aria-current={location.pathname === "/quote-builder" ? "page" : undefined}
          onClick={() => setIsMenuOpen(false)}
        >
          Build a Package
        </Link>

        <Link
          to="/about"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          About
        </Link>

        <a
          href="/brief/"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          <span className="brief-label-desktop">The Brief</span>
          <span className="brief-label-mobile">The Team Event Brief</span>
        </a>

        <Link
          to="/partners"
          className="nav-link"
          onClick={() => setIsMenuOpen(false)}
        >
          For Partners
        </Link>

        <Link
          to="/planning-assistance"
          className="nav-cta"
          onClick={() => setIsMenuOpen(false)}
        >
          Get Planning Help
        </Link>
      </nav>

      {isMenuOpen && (
        <button
          type="button"
          className="nav-scrim"
          aria-label="Close navigation menu"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Navbar;
